import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { ResourcePlanningWeekPage } from "@src/components/modules/resource-planning/my-week/ResourcePlanningWeekPage";
import { FullScreenContainer } from "@src/components/ui-kit";
import { ResourcePlanningNavigation } from "@src/components/widgets/AppSubNav";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    fullWidth
    noGutters
    noTopMargin
    noBottomMargin
    title={t`My week`}
    navigation={<ResourcePlanningNavigation />}
  >
    <DemoModule module={Modules.ResourcePlanning}>
      <FullScreenContainer heightOffset="-4rem" noBottomMargin>
        <ResourcePlanningWeekPage />
      </FullScreenContainer>
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/resource-planning/my-week/")({
  component: Page,
});
